/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

interface Param {
  circleTypeID: number // 1 Family //2 Friends //3 Colleague
  circleName: string
}

export const useCreateGroup = () => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.CREATE_GROUP],
    mutationFn: async (data: Param) => {
      const response = await axios.api.post('ajax/circles', {
        requestType: 'circleAdd',
        circleTypeID: data.circleTypeID, // 1 Family //2 Friends //3 Colleague
        circleName: data.circleName,
        format: 'json',
      })
      return response.data
    },
  })
}
